import { render, staticRenderFns } from "./fixedBtn.vue?vue&type=template&id=b6cb8c9c&scoped=true&"
import script from "./fixedBtn.vue?vue&type=script&lang=js&"
export * from "./fixedBtn.vue?vue&type=script&lang=js&"
import style0 from "./fixedBtn.vue?vue&type=style&index=0&id=b6cb8c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb8c9c",
  null
  
)

export default component.exports